import { ElementRef, EventEmitter, Output } from '@angular/core';
import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { attendee } from 'src/app/models/attendee';
import { MeetingResponse } from 'src/app/models/basicMeetingModel';
import { AttendeeService } from 'src/app/service/attendee.service';
import { Globals } from 'src/app/service/global';
import { environment, environment_msg } from 'src/environments/environment';
// import * as $ from 'jquery';
import $ from 'jquery';

import { UserService } from 'src/app/service/user.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { data } from 'jquery';
import { E } from '@angular/cdk/keycodes';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-attendee-dialog',
  templateUrl: './attendee-dialog.component.html',
  styleUrls: ['./attendee-dialog.component.css']
})
export class AttendeeDialogComponent implements OnInit{
  roleList: any = [];
  
  @ViewChild('attId', { static: false }) attId!: ElementRef;
  @ViewChild('editModalClose') closeEditModal!: ElementRef<HTMLElement>;
  @Output() dataToParent = new EventEmitter();
  @Output() onInitEvent = new EventEmitter();
  editAttendeeForm !: any;
  attRole!: any;
  attendeeName!: string;
  attendeeEmail!: string;
  selectedVal!: string;
  attName!: any;
  attUserId!: any;
  attendeeRoleCode!: string;
  attendeeRole!: string;
  fkCodelstAttendeeRole!: string;
  attendeeId!: number;
  meetingId!:number;
  dataList!: any;
  attendeeDes!: string;
  private readonly notifier!: NotifierService;


  attendeeObj: attendee[] = [];
  @Input() meetingResponse!:MeetingResponse;
  roleCodeVal: any;
  globleRole:any;
  newUserDetails: any;
  attendeeList: any;
  addAttendeejsonobj:any;
  isGuestUser: any;
  disableRoleList: any;
  attendeeJson: any;
  isJoined: any;
  oldRoleValue: any;
  availableStatus: any;

  existFacObj: any;
  logType!: string;
  attendeeIsPresent!: string;
  
  isChecked: boolean = true;
  userId: any;
  attendeeForm: UntypedFormGroup;

  constructor(notifierService: NotifierService,private websocket:WebsocketTransferService,private spinner: NgxSpinnerService,private dialog : MatDialog,private sideNav : SideNavServiceService,private userService:UserService,private attendeeService: AttendeeService,private globals: Globals, private _mdr: MatDialogRef<AttendeeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any, private fb: UntypedFormBuilder) {
      this.roleList = this.globals.userRoleList;
      this.attendeeList = data.attendeeList;
      this.logType = data.logType;
      this.attendeeIsPresent = data.attendeeIsPresent;
      if(this.attendeeIsPresent == 'Y'){
        this.isChecked = true;
      }else{
        this.isChecked = false;
      }
      
          this.userId = localStorage.getItem('userId');
      this.notifier = notifierService;

    this.attendeeName = data.attendeeName;
    this.attendeeEmail = data.attendeeEmail;
    //this.roleList = data.roleList;
    this.attRole = data.attRole;
    this.globleRole=data.attRole;
    this.attUserId = data.attUserId;
    this.dataList = data;
    this.attendeeRole = data.attendeeRole;
    this.fkCodelstAttendeeRole = data.fkCodelstAttendeeRole;
    this.attendeeRoleCode = data.attendeeRoleCode;
    this.attendeeId = data.attendeeId;
    this.meetingId = data.meetingId;
    this.roleCodeVal = data.attRole;
    this.isGuestUser = data.isGuestUser;
    this.isJoined = data.isJoined;
    this.availableStatus = data.availableStatus;


    this.attendeeJson = data.attendeejson;

    this.oldRoleValue = data.attendeeRoleCode

    this.attendeeForm = this.fb.group({
      mail: ['', [Validators.email, this.emailValidator]],
    });
  }
  emailValidator(control: { value: string; }) {
    // Regular expression for email validation with dot (.) and @
    const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return EMAIL_REGEXP.test(control.value) ? null : { invalidEmail: true };
  }
  roleValue(attrole:any){

    
    this.roleCodeVal = attrole;
    if(this.isGuestUser == 1){
      this.disableRoleList = true;
    }else{
      this.disableRoleList = false;
    }

  
   }
  
  saveEditedAttendee(event: any) {
    if (this.attendeeForm.valid) {
      this.spinner.show();
      
      
      if(this.attUserId == undefined){
        this.attUserId = null;
      }

      
      var isFacilitator = "FAC";

    //Changing Facilitator into Attendee or Note Taker without having Chairperson
      if((this.attendeeRoleCode == "ATT" || this.attendeeRoleCode == "NT") && ($("#displayAttendeeSec").find('div#roleCode_CP').length <= 0 && this.oldRoleValue == "FAC")){
        
        this.sideNav.alertAttendeeRole('attendeeRole')
        this.attRole=this.globleRole;
        this.spinner.hide();
      }
      //changing chairperson to attendee or Note taker without having facilitator or chairperson.
      else if(($("#displayAttendeeSec").find('div#roleCode_CP').length <= 1 && $("#displayAttendeeSec").find('div#roleCode_FAC').length <=0 && this.oldRoleValue == "CP") &&  (this.attendeeRoleCode == "ATT" || this.attendeeRoleCode =="NT")){
        
        this.attRole=this.globleRole;
        this.sideNav.alertChangeFacilitator("attendeeRole");
        this.spinner.hide();
      }
      //Changing Attendee or Note Taker into Facilitator without having Chairperson and have one Facilitator.
      else if((this.attendeeRoleCode == "FAC" && (this.oldRoleValue == "NT" || this.oldRoleValue == "ATT")) && ($("#displayAttendeeSec").find('div#roleCode_FAC').length > 0)){
        
        this.dialog.open(ConfirmDialogComponent, {       
          data: {
            dialogTitle : "Confirmation",
            dialogContent : environment_msg.msg_confirm_change_facilitator
          },
        }).afterClosed().subscribe(response => {
              //
          if(response == true){
            //fetching existing faciliator from attendee list and changing as Attendee
            let index = this.attendeeList?.indexOf(this.attendeeJson);
            if (index !== -1 && index != null) {
              var changeFacasAttobj =
              {
                "attendeeName": this.attendeeJson.attendeeName,
                "attendeeEmail": this.attendeeJson.attendeeEmail,
                "fkCodelstAttendeeRole": this.attendeeJson.fkCodelstAttendeeRole,
                "attendeeIsPresent": this.attendeeJson.attendeeIsPresent,
                "attendeeId": this.attendeeJson.attendeeId,
                "fkSecUserAttendee": this.attendeeJson.fkSecUserAttendee,
                "attendeeRole": this.attendeeRole,
                "createdBy": this.attendeeJson.createdBy,
                "attendeeRoleCode": this.oldRoleValue,
                "deletedFlag": 0,
                "logType": "IN",
                "availableStatus": this.attendeeJson.availableStatus,
                "isJoined":this.attendeeJson.isJoined,
              }
              this.attendeeService.editAttendee(changeFacasAttobj).subscribe((data: any) => {
              });
              this.attendeeList?.splice(index, 1, changeFacasAttobj);
            }
              //changing current use as Facilitator
              this.addAttendeejsonobj = {
                //"attendee": {
                  "attendeeName": this.attendeeName,
                  "attendeeEmail": this.attendeeEmail,
                  "fkCodelstAttendeeRole": this.fkCodelstAttendeeRole,
                  // "attendeeIsPresent": "Y",
                  "attendeeIsPresent": this.attendeeIsPresent,
                  "attendeeId": this.attendeeId,
                  "fkSecUserAttendee": this.attUserId,
                  "attendeeRole": this.attendeeRole,
                  "availableStatus" : this.availableStatus,
                  //"createdBy": this.attUserId,
                  "attendeeRoleCode": this.attendeeRoleCode,
                  //"deletedFlag": 0,
                  "meetingId":this.meetingId,
                  "userType":this.globals.userType,
                  "orgId":this.globals.orgId,
                  "userId":this.globals.userId,
                  "isJoined":this.isJoined,
                  "isGuestUser":this.isGuestUser
              }
              this.saveUpdatedAttendee();
          }
        });
      this.spinner.hide();
      }
      //Changing Attendee or Note Taker or Chairperson to Note taker or Chairperson or Attendee.
      else if((this.attendeeRoleCode == "ATT" || this.attendeeRoleCode == "NT" || this.attendeeRoleCode == "CP") && (this.oldRoleValue == "ATT" || this.oldRoleValue == "NT" || this.oldRoleValue == "CP")){
        
        this.saveUpdatedAttendee();
        //this.spinner.hide();
      }
      //Changing Facilitator to Chairperson
      else if(this.attendeeRoleCode == "CP" && this.oldRoleValue == "FAC"){
        
        this.saveUpdatedAttendee();
      // this.spinner.hide();
      }
      //Changing Facilitator to Attendee or Note Taker having min One chairperson and having max one Facilitator Means. (fac value comes here one) 
      else if(this.oldRoleValue == "FAC" && ($("#displayAttendeeSec").find('div#roleCode_CP').length >= 1 && $("#displayAttendeeSec").find('div#roleCode_FAC').length <= 1) && (this.attendeeRoleCode == "CP" || this.attendeeRoleCode == "ATT" || this.attendeeRoleCode == "NT")){
        
        this.saveUpdatedAttendee();
      // this.spinner.hide();
      }
      //changing Attendee or Note taker or chairperson to Facilitator having one Chairperson  and without facilitator.
      else if((this.oldRoleValue == "ATT" || this.oldRoleValue == "NT" || this.oldRoleValue == "CP") && ($("#displayAttendeeSec").find('div#roleCode_FAC').length <= 0 && $("#displayAttendeeSec").find('div#roleCode_CP').length > 0 && this.attendeeRoleCode == "FAC")){
        
        this.saveUpdatedAttendee();
      // this.spinner.hide();
      }
      //changing attendee or note taker or chairperson to facilitator having one facilitator means.
      else if(($("#displayAttendeeSec").find('div#roleCode_FAC').length <= 1 && this.attendeeRoleCode == "FAC") && (this.oldRoleValue == "ATT" || this.oldRoleValue == "NT" || this.oldRoleValue == "CP")){
        
        this.attRole=this.globleRole;
        this.sideNav.alertMultiFacilitator("changeFAC")
        this.spinner.hide();
      }else if(this.oldRoleValue == "FAC" && this.attendeeRoleCode == "FAC"){
        this.saveUpdatedAttendee();
      // this.spinner.hide();
      }
      else{ 
        this.sideNav.alertChangeFacilitator("changeFAC")
        this.attRole=this.globleRole;
        this.sideNav.alertChangeFacilitator("attendeeRole");
        this.spinner.hide();
      }
    }else{
      this.notifier.show({
        type: 'error',
        message: 'Please enter a valid email address.'
      });
    }
  }

checkEmailExists(){
  var userId:any = [];
  
  let isUserExistObj = {
    "email" : this.attendeeEmail
  }

  this.userService.checkEmailExists(isUserExistObj).subscribe((data: any) => {
    
    this.newUserDetails = data.body;
    this.attendeeList.forEach((element:any) => {
     userId.push(Number(element.fkSecUserAttendee));
    });
    var newUser = userId.indexOf(this.newUserDetails.userId);
      if(newUser < 0){
          this.attUserId = this.newUserDetails.userId;
          if(this.newUserDetails.firstName && this.newUserDetails.lastName != null){
            this.attendeeName = this.newUserDetails.firstName+" "+this.newUserDetails.lastName;
          
          }else{
            this.attendeeName = this.attendeeName;
            
          }
          //this.spinner.hide();
      }else{
        this.attendeeEmail='';
        //this.spinner.hide();
        this.notifier.notify("warning", "Participant already added to this meeting");
      }
  }); 
}

  saveUpdatedAttendee(){
    
     var attOrganiztionId :any;
     if(this.newUserDetails!= undefined && this.newUserDetails != null){
       attOrganiztionId = this.newUserDetails.organizationId;
     }else{
       attOrganiztionId = null;
     }
    this.addAttendeejsonobj = {
      //"attendee": {
        "attendeeName": this.attendeeName,
        "attendeeEmail": this.attendeeEmail,
        "fkCodelstAttendeeRole": this.fkCodelstAttendeeRole,
        // "attendeeIsPresent": "Y",
        "attendeeIsPresent": this.attendeeIsPresent,
        "attendeeId": this.attendeeId,
        "fkSecUserAttendee": this.attUserId,
        "attendeeRole": this.attendeeRole,
        "availableStatus" : this.availableStatus,
        //"createdBy": this.attUserId,
        "attendeeRoleCode": this.attendeeRoleCode,
        //"deletedFlag": 0,
        "meetingId":this.meetingId,
        "userType":this.globals.userType,
        "orgId":this.globals.orgId,
        "userId":this.globals.userId,
        "organizationId":attOrganiztionId,
        "isJoined":this.isJoined,
        "isGuestUser":this.isGuestUser
      //}
    }

    
    this.attendeeService.editAttendee(this.addAttendeejsonobj).subscribe((data: any) => {
      this.spinner.hide()
      
      data['isJoined'] = this.isJoined;
      data['attendeeIsPresent'] = this.attendeeIsPresent;
      data['logType'] = this.logType;
      this._mdr.close(data);
      //this._mdr.close(false);

    });
  }
  ngOnInit(): void {
    $("#editAttendeeDialog").find("#attUserId").val(this.attUserId);
    this.loadEditedUserInfo();
  }
  closeDialog() {
    this._mdr.close(false)
  }
  onAttRoleChange(event: any) {
    
    this.attendeeRole = event.source.triggerValue;
    this.attendeeRoleCode = event.value;
  }

  loadAttendeeEdit($inputor: any){
    ////consolee.log("inside load Atendee EDit>>>"+JSON.stringify($inputor));
    $inputor.off("inserted.atwho");
    $inputor.on("inserted.atwho", (_$event: any, _$li: any, _query: any) => {
      this.attendeeEmail = _$li.data('item-data').email;
      this.attUserId =  _$li.data('item-data').id;
      this.attendeeName = _$li.data('item-data').value;
      this.attendeeRoleCode = environment.defAttendeeRoleCode;
  });
}

  loadEditedUserInfo() {
    this.attendeeService.loadAttendeeAgendaPresenter(true, "EDTATT", null)
      .then((result: any) => {
        // //
        this.loadAttendeeEdit(result)
      });
  }
// This method will be called when the checkbox state changes
onCheckboxChange() {
  this.isChecked = !this.isChecked;
  
  
  if(this.isChecked){
    this.attendeeIsPresent = 'Y'
    if(this.logType==null)
    this.logType = 'IN'
  } else{
    this.attendeeIsPresent = 'N'
    if(this.logType==null)
    this.logType = 'OUT'
  }
}
get f() {
  return this.attendeeForm.controls;
}
}
